module.exports = __webpack_public_path__ + "img/et-brand.0e38dc0d.webp";